module.exports = __webpack_public_path__ + "static/media/Calibre-MediumItalic.6eb2ac5a.ttf";